import { useMediaQuery } from 'usehooks-ts'
import { deviceSizes } from '@reward-platform/lift/theme/deviceSizes'
import { createContext, PropsWithChildren, useContext, useMemo } from 'react'

type DeviceMatchResult = {
  isDesktop?: boolean
  isTablet?: boolean
  isMobile?: boolean
}

const MediaQueryContext = createContext<DeviceMatchResult>({})

export function useDeviceMatch() {
  return useContext(MediaQueryContext)
}

export function MediaQueryProvider({ children }: Readonly<PropsWithChildren>) {
  const isMobile = useMediaQuery(`(max-width: ${deviceSizes.medium})`)
  const isTablet = useMediaQuery(
    `(min-width: ${deviceSizes.medium}) and (max-width: ${deviceSizes.large})`
  )
  const isDesktop = useMediaQuery(`(min-width: ${deviceSizes.large})`)

  const deviceMatch: DeviceMatchResult = useMemo(
    () => ({ isDesktop, isTablet, isMobile }),
    [isDesktop, isTablet, isMobile]
  )
  return <MediaQueryContext.Provider value={deviceMatch}>{children}</MediaQueryContext.Provider>
}
